import React from 'react';

const VodacomRedLogo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M16 8.00006C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8.00006C0 3.58169 3.58172 0 8 0C12.4183 0 16 3.58169 16 8.00006Z" fill="#E60000"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M8.09118 12.5998C5.89498 12.6071 3.61011 10.724 3.60013 7.70027C3.59347 5.70064 4.66733 3.77585 6.03997 2.63391C7.37883 1.52012 9.21303 0.805322 10.8765 0.799826C11.0907 0.79909 11.3147 0.81705 11.4517 0.863623C9.99723 1.16669 8.83963 2.5266 8.84476 4.0694C8.84493 4.12039 8.8495 4.17489 8.85446 4.20028C11.2884 4.79581 12.3933 6.27119 12.4001 8.31263C12.4067 10.354 10.8025 12.5907 8.09118 12.5998Z" fill="white"/>
    </svg>
  );
};

export default VodacomRedLogo;